import MetricBadge from './MetricBadge.jsx';

const TONE = {
  connected: 'ok',
  disconnected: 'info',
  error: 'bad',
  pending: 'info',
  Conectado: 'ok',
  'No conectado': 'info',
  Error: 'bad',
  'Pendiente de configuración': 'info'
};

export default function IntegrationStatusCard({ name, status, lastSync, detail }) {
  const tone = TONE[status] || 'info';
  return (
    <article className="analytics-integration-card">
      <div className="analytics-integration-card-head">
        <h3>{name}</h3>
        <MetricBadge tone={tone}>{status}</MetricBadge>
      </div>
      {lastSync ? <p className="analytics-integration-meta">Última sync: {lastSync}</p> : null}
      {detail ? <p className="analytics-integration-meta">{detail}</p> : null}
    </article>
  );
}
